import { combineReducers } from 'redux';

function usersReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_USER_COMPLETION': {
      if (action.error) {
        return state;
      }

      return {
        ...state,
        [action.userId]: action.data,
      };
    }

    case 'LOAD_OWN_COMPLETION': {
      const { error, own } = action;

      if (error) {
        return state;
      }
      if (!own) {
        return state;
      }

      return {
        ...state,
        [own.uid]: own,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  users: usersReducer,
});
